import React from 'react';
import classNames from 'classnames';
import {useI18n} from '@udemy-v2/i18n';
import {Icon} from '@udemy-v2/icons';

import {ClpPrimaryCtaButton} from '@/features/course-landing-page/components/clp-primary-cta-button/clp-primary-cta-button.react-component';
import {CourseIncludes} from '@/features/course-landing-page/components/course-includes/course-includes.react-component';
import {MarketplaceUfbNotice} from '@/features/course-landing-page/components/marketplace-purchase-content/marketplace-ufb-notice.react-component';
import {CourseContentPlacement} from '@/features/course-landing-page/course-landing-page.react-component';

import styles from './enrolled-box.module.scss';
import {ClpSecondaryActions} from '@/features/course-landing-page/components/clp-secondary-actions';

interface EnrolledBoxProps {
    placement: CourseContentPlacement;
}

/**
 * EnrolledBox component displays content for non-PP users who have already enrolled in the course.
 * Includes enrolled message, CTA button, course includes, marketplace notice, and money-back guarantee.
 */
export const EnrolledBox = ({placement}: EnrolledBoxProps) => {
    const {gettext} = useI18n();
    const isSidebarPlacement = CourseContentPlacement.SIDEBAR === placement;

    return (
        <div className={styles.container} data-purpose="enrolled-box">
            <div className={styles['enrolled-message-container']}>
                <Icon color="info" glyph="info" label={false} />
                <span className={classNames('ud-text-bold', styles['enrolled-message'])}>
                    {gettext('You purchased this course')}
                </span>
            </div>

            <div className={styles['cta-container']}>
                <ClpPrimaryCtaButton udStyle="primary" />
            </div>

            <div className={classNames(styles['money-back-guarantee-container'])}>
                <span className="ud-text-xs" data-purpose="money-back-guarantee">
                    {gettext('30-Day Money-Back Guarantee')}
                </span>
            </div>
            {isSidebarPlacement && <CourseIncludes />}
            <ClpSecondaryActions />
            {isSidebarPlacement && <MarketplaceUfbNotice />}
        </div>
    );
};
